/*
 * Content scope for album pages: network-level content lives at /<network>/album/…,
 * group content at /<network>/<group-slug>/album/…. Back, the player, payment returns and
 * subscription links are all built from the active scope, so the URL must match the content.
 */

/**
 * The group slug the content belongs to: a slug for group content, null for network-level
 * content, undefined when the group cannot be identified (then nothing should change).
 */
export function contentGroupSlug(networkGroupId: any, groups: any[]): string | null | undefined {
  const id = Number(networkGroupId || 0);
  if (!id) return null;
  const group = (groups || []).find((g: any) => Number(g?.id) === id);
  return group?.group_slug || undefined;
}

/** The same album URL in another scope; everything from `/album` onwards (and the query) is kept. */
export function rescopeAlbumUrl(url: string, network: string, groupSlug: string | null): string | null {
  if (!url || !network) return null;
  const [path, query] = url.split('?');
  const parts = path.split('/').filter(Boolean);
  const albumIndex = parts.indexOf('album');
  if (albumIndex < 1) return null;
  const prefix = groupSlug ? [network, groupSlug] : [network];
  return '/' + prefix.concat(parts.slice(albumIndex)).join('/') + (query ? '?' + query : '');
}
